import Vue from "vue";
import VueCarousel from 'vue-carousel';
import DiscountPartnerSlider from './components/DiscountPartnerSlider.vue';

Vue.use(VueCarousel);
Vue.component('partner-slider', DiscountPartnerSlider);

if(document.getElementById("partner-slider")) {
    new Vue({el: '#partner-slider'});
}

window.onload = function () {
    let copyDiscountsContainer = document.getElementsByClassName('hepster-discounts')[0];
    let copyBtns = copyDiscountsContainer.getElementsByClassName('btn-secondary');
    Array.from(copyBtns).forEach(function (copyButton, idx) {
        let codeCopyText = document.querySelectorAll('.voucher-code')[idx].dataset.voucherCopy;
        let codeCopiedText = document.querySelectorAll('.voucher-code')[idx].dataset.voucherCopied;
        copyButton.addEventListener('click', function (event) {
            let input = event.target.parentNode.getElementsByTagName('input')[0];
            input.setAttribute('type', 'text');
            input.select();
            document.execCommand('copy');
            input.setAttribute('type', 'hidden');

            // replace button text
            copyButton.innerHTML = '<span class="glyphicon glyphicon-check"></span> ' + codeCopiedText;

            // undo original button text after 2 seconds
            setTimeout(function(){
                copyButton.innerHTML = codeCopyText;
            }, 2000);
        });
    });
};
